import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main,
  },
  menuButton: {
    marginRight: theme.spacing(0.75),
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3.4),
  },
  toolbar: theme.mixins.toolbar,
  toolbarGutters: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 300,
    },
  },
  nested: {
    paddingLeft: theme.spacing(3),
  },
  settings: {
    position: 'absolute',
    right: theme.spacing(1),
  },
  currentMenu: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  subIcon: {
    marginRight: 5,
  },
  avatar: {
    width: 24,
    height: 24,
  },
  dot: {
    fontSize: 6,
    marginRight: theme.spacing(2.25),
  },
  nextItemText: {
    paddingLeft: theme.spacing(1),
  },
}));

export default useStyles;
